import React from "react";
import { DealsContext } from "@Src/routes/deals/Deals.context";
import GenerateCoupon from "./Redeem/generateCoupon";

export default function ScreenShowGenerateCoupon({ which, program, language }) {
  const context = React.useContext(DealsContext);

  return (
    <div className="ScreenShowGenerateCoupon">
      <GenerateCoupon
        store_info={context.store}
        redeem_type={which}
        redeem_link={context.currentOffer.links.redeem_offer[which]}
        offer={context.currentOffer}
        program={program}
        language={language}
      />
    </div>
  );
}
